import { Moment } from 'moment';

export enum CommissionByMovementReportType {
  estimatorSeller,
  employeePerOsItem,
  paintedPart,
}

export enum CommissionByMovementFilterByOsDate {
  entry,
  authorization,
  closing,
}

export enum CommissionByMovementCalculationType {
  baseValue,
  liquidValue,
}

export enum CommissionByMovementOsStatusType {
  authorized = 'AUTHORIZED',
  closed = 'CLOSED',
  open = 'OPEN',
}

export interface CommissionByMovementFormValues {
  reportType: CommissionByMovementReportType;
  companiesIds?: number[];
  employeesIds?: number[];
  groupIds?: number[];
  filterByOsDate: CommissionByMovementFilterByOsDate;
  osType?: string[];
  calculationType?: CommissionByMovementCalculationType;
  osStatus: CommissionByMovementOsStatusType;
  parts: boolean;
  providedParts: boolean;
  services: boolean;
  outsource: boolean;
  directSale?: boolean;
  detailSoldItems?: boolean;
  inhibitLiquidValue?: boolean;
  finalDate: Moment;
  initialDate: Moment;
  onlyPrivate?: boolean;
}

export interface QuestCommissionByMovementRequest {
  reportType: CommissionByMovementReportType;
  companiesIds?: string;
  employeesIds?: string;
  groupIds?: string;
  filterByOsDate: CommissionByMovementFilterByOsDate;
  osTypes?: string;
  calculationType?: CommissionByMovementCalculationType;
  authorizationFilter: boolean;
  closedFilter: boolean;
  openFilter: boolean;
  parts: boolean;
  providedParts: boolean;
  services: boolean;
  outsource: boolean;
  directSale?: boolean;
  detailSoldItems?: boolean;
  inhibitLiquidValue?: boolean;
  startDate: string;
  endDate: string;
}
